import axios from 'axios';

// ─── Public axios instance (NO JWT) ──────────────────────────────────────
// For unauthenticated, token-scoped endpoints (the customer eKYC self-service
// page). Same base URL, but never attaches the admin JWT and never redirects to
// /login on 401 — the eKYC page carries its own short-lived public session token
// in the Authorization header explicitly when needed. Session renewal and sign-out
// use it too, so a refused refresh token cannot recurse into the 401 handling.
//
// A module of its own so the auth store can use it: lib/api imports the store.
export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api/v1` : '/api/v1',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});
